module.exports = __webpack_public_path__ + "img/calendar-dark.32ef65a2.svg";